import { Routes, Route } from "react-router-dom";
import "./index.css";
import NavBar from "./componets/NavBar";
import Home from "./Pages/HomePage/Home";
import About from "./Pages/AboutPage/About";
import Property from "./Pages/PropertyPage/Property";
import Contact from "./Pages/ContactPage/Contact";
import ContextProvider from "./componets/ContextProvider";
import Footer from "./componets/Footer";
import Listing from "./Pages/ListingPage/Listing";
import Error from "./Pages/ErrorPage/Error";

function App() {
  return (
    <div>
      <ContextProvider>
        <Routes>
          <Route element={<NavBar />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/property-details" element={<Property />} />
            <Route path="/listing" element={<Listing />} />
            <Route path="*" element={<Error />} />
          </Route>
        </Routes>
      </ContextProvider>
      <Footer />
    </div>
  );
}

export default App;
